import React from 'react';
import Select, { GroupBase, StylesConfig } from 'react-select';
import { fetcher } from '../services/api';
import { CleanDeliveryMethod } from '../export-types/cleaned-types';
import useSWR from 'swr';

type Props = {
  onChange?: (data: CleanDeliveryMethod[]) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  name: string;
  placeholder?: string;
  supplierId: number;
  value: CleanDeliveryMethod[];
  styles?: StylesConfig<
    CleanDeliveryMethod,
    true,
    GroupBase<CleanDeliveryMethod>
  >;
};

export function getLoader(supplierId: number) {
  return async (inputValue: string) => {
    const result = (await fetcher(
      '/delivery-method',
    )) as Array<CleanDeliveryMethod>;
    return result.filter(
      (method) =>
        method.supplier?.id === supplierId &&
        method.name.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };
}

export const DeliveryMethodsMultiSelect = React.forwardRef(function (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  const { data = [] } = useSWR<Array<CleanDeliveryMethod>>(
    '/delivery-method',
    fetcher,
  );

  const options = data.filter(
    (method) => method.supplier?.id === props.supplierId,
  );

  return (
    <Select
      name={props.name}
      placeholder={props.placeholder}
      onBlur={props.onBlur}
      options={options}
      getOptionLabel={(option) =>
        `${option.name} / ${option.deliveryPeriodFrom} - ${option.deliveryPeriodTo} дней / ${option.supplier?.name} / ${option.minWeight} - ${option.maxWeight}`
      }
      defaultOptions={true}
      getOptionValue={(option) => option.id}
      isMulti={true}
      onChange={(methods) =>
        props.onChange ? props.onChange(methods.concat()) : undefined
      }
      onFocus={props.onFocus}
      styles={props.styles}
      value={props.value}
      // @ts-ignore
      ref={ref}
    />
  );
});
